import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { CarrotquestConfig, SupportWidgetConfig } from './types'
import classes from './CarrotquestWidget.scss'
import { RootState } from 'cityads-v3/types/reducer';
import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

const SCRIPT_ID = 'carrotquestwidget'
const MAX_THEME_LENGTH = 20;
const langMap: { [index: string]: string } = {
  ru: require('./CarrotquestLang/ru.json'),
  en: require('./CarrotquestLang/en.json'),
  es: require('./CarrotquestLang/es.json'),
}

type CarrotquestWidgetProps = SupportWidgetConfig<CarrotquestConfig> & {}

export default function CarrotquestWidget({
  script,
  config: { projectid, userFullname, userEmail, hash, userId }
}: CarrotquestWidgetProps): JSX.Element {
  const lang = useSelector((state: RootState) => state.language.language);

  const createWidget = useCallback(() => {
    (function () {
      function t(t: any) {
        return function () {
          window.carrotquestasync.push(t, arguments)
        }
      }
      if ("undefined" == typeof window.carrotquest) {
        var e = document.createElement("script");
        e.type = "text/javascript";
        e.async = !0;
        e.src = script;
        e.id = SCRIPT_ID;
        document.getElementsByTagName("head")[0].appendChild(e);
        window.carrotquest = {};
        window.carrotquestasync = [];
        window.carrotquest.settings = {};

        for (var n = ["connect", "track", "identify", "auth", "onReady", "addCallback", "removeCallback", "trackMessageInteraction"], a = 0; a < n.length; a++) {
          window.carrotquest[n[a]] = t(n[a])
        }
      }
    })();

    window.carrotquest.auth(userId, hash)
    window.carrotquest.identify({
      '$email': userEmail,
      '$name': userFullname,
    })
    window.carrotquest.connect(projectid, {
      i18n: langMap[lang] ?? langMap.en
    });

  }, [script, projectid, userFullname, userEmail, userId, hash, lang])

  const widgetEventsCallback = useCallback((data: { body: string }) => {
    const text = data.body || '';
    const theme = text.substring(0, MAX_THEME_LENGTH) + (text.length > MAX_THEME_LENGTH ? '…' : '');

    amplitudeSendEvent('makeActions', 'd-v1-e39', 'help_button', 'question_ask', {
      question_topic: theme,
    });
  }, [])

  useEffect(() => {
    createWidget()
    window.carrotquest.addCallback('conversation_started', widgetEventsCallback)
    window.carrotquest.addCallback('user_replied', widgetEventsCallback)

    return () => {
      const script = document.getElementById(SCRIPT_ID) as HTMLScriptElement;

      if (script) {
        script.src = null;
        script.parentNode?.removeChild(script);
      }

      const container = document.getElementById('carrotquest-messenger-collapsed-container');
      if (container) {
        container.parentNode?.removeChild(container);
      }

      document.getElementById('proxy-iframe')?.parentNode?.removeChild(document.getElementById('proxy-iframe'));

      delete window.carrotquest;
    }
  }, [createWidget, widgetEventsCallback])

  return (
    <>
      <Helmet>
        <body className={classes.bodyHasCarrotquestWidget} />
      </Helmet>
    </>
  )
}
